import React, { useState, useEffect } from "react";
import { Badge, Row, Col, Collapse } from "react-bootstrap";
import Swal from "sweetalert2";
import { CommonModal, CommonButton, CommonSelect } from "../Input";
import DataTable from "../table/DataTable";
import { initialDenominations } from "./mockData";

const CreateCashVaultTransactionModal = ({ show, onHide }) => {
  const [type, setType] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [bank, setBank] = useState(null);
  const [reason, setReason] = useState("");
  const [denominations, setDenominations] = useState(initialDenominations);

  useEffect(() => {
    if (show) {
      setType(null);
      setCurrency(null);
      setBank(null);
      setReason("");
      setDenominations(initialDenominations.map((d) => ({ ...d, qty: "" })));
    }
  }, [show]);

  const typeOptions = [
    { label: "Deposit Cash", value: "deposit" },
    { label: "Withdraw Cash", value: "withdraw" },
    { label: "Withdraw Cash to Bank", value: "withdraw_bank" },
  ];

  const currencyOptions = [{ label: "US Dollar", value: "USD" }];

  const bankOptions = [
    { label: "DBS BANK", value: "dbs" },
    { label: "OCBC BANK", value: "ocbc" },
    { label: "UOB BANK", value: "uob" },
  ];

  const handleQtyChange = (id, newQty) => {
    setDenominations((prev) =>
      prev.map((item) => (item.id === id ? { ...item, qty: newQty } : item)),
    );
  };

  const updatedTotal = denominations.reduce((sum, item) => {
    const qty = parseInt(item.qty) || 0;
    return sum + item.value * qty;
  }, 0);

  const showTable = type && currency;
  const isBankType = type && type.value.includes("bank");

  const columns = [
    {
      label: "IMAGE",
      key: "image",
      className: "ps-4 text-center",
      cellClassName: "ps-4 text-center",
      style: { width: "100px" },
      render: (item) => (
        <div
          className="d-flex align-items-center justify-content-center border rounded bg-white overflow-hidden mx-auto"
          style={{ width: "45px", height: "30px", borderColor: "#eee" }}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.label}
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <div className="text-muted fs-8 fw-bold">$</div>
          )}
        </div>
      ),
    },
    {
      label: "DENOMINATION",
      key: "label",
      style: { width: "250px" },
      render: (item) => (
        <span className="fs-13 fw-bold text-black">{item.label}</span>
      ),
    },
    {
      label: "INVENTORY",
      key: "inventory",
      className: "text-center",
      cellClassName: "text-center",
      style: { width: "150px" },
      render: (item) => (
        <div className="d-flex align-items-center justify-content-center">
          {item.inventory !== "-" && (
            <div
              className="rounded-circle me-1"
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#34D399",
              }}
            />
          )}
          {item.inventory !== "-" ? (
            <span className="fw-bold fs-12 text-black">{item.inventory}</span>
          ) : (
            <span className="text-muted">—</span>
          )}
        </div>
      ),
    },
    {
      label: "QUANTITY",
      key: "quantity",
      className: "text-center",
      cellClassName: "text-center",
      style: { width: "200px" },
      render: (item) => (
        <div className="d-flex justify-content-center">
          <input
            type="number"
            min="0"
            className="form-control text-center py-1"
            value={item.qty}
            onChange={(e) => handleQtyChange(item.id, e.target.value)}
            style={{
              height: "36px",
              width: "100px",
              fontSize: "13px",
              borderColor: "#E2E8F0",
              borderRadius: "8px",
            }}
          />
        </div>
      ),
    },
    {
      label: "TOTAL",
      key: "total",
      className: "pe-4 text-end",
      cellClassName: "pe-4 text-end",
      style: { width: "180px" },
      render: (item) => {
        const qty = parseInt(item.qty) || 0;
        return (
          <div className="fw-bold fs-13 text-black">
            SGD{" "}
            {(item.value * qty).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
          </div>
        );
      },
    },
  ];

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title="Create Cash Vault Transaction"
      fullscreen={true}
      headerClassName="px-4 py-3"
      footerClassName="bg-white pb-4 pt-0 pe-5 border-top-0 d-flex justify-content-end"
      footer={
        <div className="d-flex gap-3">
          <CommonButton
            variant="outline"
            className="px-5 bg-white border"
            style={{
              borderColor: "#D0D5DD",
              color: "#344054",
              fontWeight: "600",
              borderRadius: "8px",
            }}
            onClick={onHide}
          >
            Close
          </CommonButton>
          <CommonButton
            className={`px-5 fw-bold ${showTable ? "text-white border-0" : ""}`}
            style={{
              borderRadius: "8px",
              backgroundColor: "var(--primary)",
            }}
            onClick={() => {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Transaction Approved Successfully!",
                confirmButtonColor: "var(--primary)",
              }).then(() => {
                onHide();
              });
            }}
          >
            Next
          </CommonButton>
        </div>
      }
    >
      <div>
        <Row className="g-4 mb-2">
          <Col md={isBankType ? 4 : 4}>
            <label className="text-black fw-bold fs-12 mb-2">Type</label>
            <CommonSelect
              placeholder="Select transaction type"
              options={typeOptions}
              value={type}
              onChange={setType}
            />
          </Col>
          <Col md={isBankType ? 4 : 4}>
            <label className="text-black fw-bold fs-12 mb-2">Currency</label>
            <CommonSelect
              placeholder="Select currency"
              options={currencyOptions}
              value={currency}
              onChange={setCurrency}
            />
          </Col>
          {isBankType && (
            <Col md={4}>
              <label className="text-black fw-bold fs-12 mb-2">Bank</label>
              <CommonSelect
                placeholder="Select bank"
                options={bankOptions}
                value={bank}
                onChange={setBank}
              />
            </Col>
          )}
        </Row>

        <Collapse in={!!showTable}>
          <div>
            <div className="d-flex justify-content-end gap-2 mb-2">
              <Badge
                bg="light"
                className="text-black border px-3 py-2 d-flex align-items-center"
                style={{
                  borderRadius: "20px",
                  fontSize: "12px",
                  backgroundColor: "#F1F5F9",
                  borderColor: "#E2E8F0",
                  height: "36px",
                }}
              >
                <span className="text-muted me-2">Total cash:</span>
                <span className="fw-bold" style={{ color: "#1E40AF" }}>
                  SGD 2,000
                </span>
              </Badge>
              <Badge
                bg="light"
                className="text-black border px-3 py-2 d-flex align-items-center"
                style={{
                  borderRadius: "20px",
                  fontSize: "12px",
                  backgroundColor: "#F1F5F9",
                  borderColor: "#E2E8F0",
                  height: "36px",
                }}
              >
                <span className="text-muted me-2">Updated Total:</span>
                <span className="fw-bold" style={{ color: "#1E40AF" }}>
                  SGD{" "}
                  {updatedTotal.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                  })}
                </span>
              </Badge>
            </div>

            <div className="card shadow-none rounded-4 overflow-hidden border border-light mb-4">
              <DataTable
                columns={columns}
                data={denominations}
                showPagination={false}
                minWidth="100%"
              />
            </div>

            {type?.value === "withdraw" && (
              <div className="mb-4">
                <label className="text-black fw-bold fs-12 mb-2">Reason</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter reason for cash withdrawal"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  style={{
                    resize: "none",
                    borderRadius: "8px",
                    borderColor: "#E2E8F0",
                  }}
                />
              </div>
            )}
          </div>
        </Collapse>
      </div>
    </CommonModal>
  );
};

export default CreateCashVaultTransactionModal;
